<template>
  <Transition name="fade-transition">
    <v-container class="cmpbk black--text" id="home-logs-container">
      <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->
      <v-app-bar
        elevation="4"
        dark
        class="backdrop lighten-1"
        height="60px"
        style="z-index: 2"
      >
        <v-spacer />
        <v-toolbar-title> RPD EverWatch Logs </v-toolbar-title>
        <v-spacer />

        <template v-slot:extension>
          <v-text-field
            filled
            outlined
            dark
            dense
            v-model="search_form.search_term"
            color="secondary"
            clearable
            :disabled="logs_type_list.length == 0"
            hide-details
            @keydown.enter="SearchLogs"
            append-icon="$send"
            @click:append="SearchLogs"
            label="Search logs"
            ref="search_field"
            prepend-inner-icon="$magnify"
            class="toolbar-textfield"
          >
            <template v-slot:append-outer>
              <v-tooltip bottom :disabled="$vuetify.breakpoint.xs" class="pb-4">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    light
                    class="px-4"
                    @click="openSearchDialog()"
                    :disabled="logs_type_list.length == 0"
                    color="white"
                    v-bind="attrs"
                    v-on="on"
                    style="top: -12px"
                  >
                    <v-icon v-if="search_filters_text.length == 0" size="30"
                      >$textSearch</v-icon
                    >
                    <v-icon v-else color="secondary" size="30"
                      >$textSearch</v-icon
                    >
                  </v-btn>
                </template>
                <span>Use Advanced Search</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </template>
      </v-app-bar>

      <v-card
        class="backdrop pa-3 pa-md-5"
        style="min-height: 525px"
        elevation="2"
      >
        <!--Data iterator-->
        <v-data-iterator
          v-if="logs_type_list.length > 0"
          :items="logs_type_list"
          hide-default-footer
          disable-pagination
          class="mx-auto white--text pb-5 pt-2 px-md-8 px-5 mb-12"
          style="max-width: 900px"
        >
          <template v-slot:default="props">
            <v-row no-gutters>
              <transition-group name="fade-transition" class="row">
                <v-col
                  v-for="(item, index) in props.items"
                  :key="index"
                  :cols="getColValue(index, props.items.length)"
                >
                  <v-badge
                    :value="item.count > 0"
                    dark
                    :content="item.count"
                    bordered
                    color="primary"
                    icon="mdi-lock"
                    overlap
                    class="patrol-type-badge black--text"
                  >
                    <v-btn
                      color="secondary"
                      class="black--text patrol-type-button"
                      large
                      @click="openLogType(item.name)"
                      block
                    >
                      {{ item.displayName }}
                    </v-btn>
                  </v-badge>
                </v-col>

                <v-col cols="12" :key="-1" v-if="$store.state.EWCanAdd">
                  <v-badge
                    :value="draft_count > 0"
                    :content="draft_count"
                    dark
                    bordered
                    color="secondary"
                    icon="mdi-lock"
                    overlap
                    class="patrol-type-badge"
                  >
                    <v-btn
                      color="primary"
                      class="black--text patrol-type-button"
                      large
                      @click="openDraftLogs()"
                      block
                      :disabled="draft_count == 0"
                    >
                      {{ drafts_type.name }}
                    </v-btn>
                  </v-badge>
                </v-col>

                <v-col cols="12" :key="-2" v-if="$store.state.EWAdmin">
                  <v-btn
                    color="red"
                    class="patrol-type-button"
                    large
                    text
                    block
                    @click="openAdmin()"
                  >
                    Admin
                  </v-btn>
                </v-col>
              </transition-group>
            </v-row>
          </template>
        </v-data-iterator>

        <!--Loading data iterator-->
        <v-data-iterator
          v-else
          :items="loading_logs_list"
          hide-default-footer
          disable-pagination
          class="mx-auto white--text pb-5 pt-2 px-md-8 px-5 mb-12"
          style="max-width: 900px"
        >
          <template v-slot:default="props">
            <v-row no-gutters>
              <transition-group name="fade-transition" class="row">
                <v-col
                  v-for="(item, index) in props.items"
                  :key="index"
                  :cols="getColValue(index,props.items.length)"
                >
                  <v-skeleton-loader
                    class="loader_button"
                    type="button"
                  ></v-skeleton-loader>
                </v-col>

                <v-col cols="12" :key="-1" v-if="$store.state.EWCanAdd">
                  <v-skeleton-loader
                    class="loader_button"
                    type="button"
                  ></v-skeleton-loader>
                </v-col>
              </transition-group>
            </v-row>
          </template>
        </v-data-iterator>

        <!-- FAB container -->
        <div class="fab-container">
          <!-- <v-fab-transition>
            <v-btn color="secondary black--text" dark fab @click="goHome()">
              <v-icon> $home </v-icon>
            </v-btn>
          </v-fab-transition> -->

          <v-fab-transition>
            <v-btn
              color="secondary black--text"
              elevation="5"
              class="mb-6"
              dark
              bottom
              fab
              @click="openNewLogsDialog"
              v-if="$store.state.EWCanAdd"
              :disabled="logs_type_list.length == 0"
            >
              <v-icon>$plus</v-icon>
            </v-btn>
          </v-fab-transition>

          <v-fab-transition>
            <v-speed-dial
              v-model="menuFAB"
              :disabled="logs_type_list.length == 0"
            >
              <template v-slot:activator>
                <v-btn
                  color="primary black--text"
                  class="mb-6"
                  dark
                  fab
                  :disabled="logs_type_list.length == 0"
                >
                  <v-icon v-if="menuFAB"> $close </v-icon>
                  <v-icon v-else> $menu </v-icon>
                </v-btn>
              </template>

              <v-btn
                color="red lighten-1 black--text"
                dark
                fab
                :disabled="logs_type_list.length == 0"
                @click="logOut"
              >
                <v-icon> $logout </v-icon>
              </v-btn>

              <v-btn
                color="green lighten-1 black--text"
                dark
                fab
                :disabled="logs_type_list.length == 0"
                @click="openHelpDialog"
              >
                <v-icon> $help </v-icon>
              </v-btn>
            </v-speed-dial>
          </v-fab-transition>
        </div>
      </v-card>

      <!-- LOG dialog -->
      <logsDialog
        v-if="logs_dialog"
        @closeDialog="closeLogsDialog"
        :mode="logs_dialog_mode"
        :logEntryIDs="logs_dialog_logEntryIDs"
      ></logsDialog>

      <!-- SEARCH dialog -->
      <searchDialog
        v-if="search_dialog"
        :search_form="search_form"
        @closeDialog="closeSearchDialog()"
        @filterTextUpdated="searchFiltersUpdated"
        @applyFilters="applySearchFilter()"
        @resetFilters="resetSearchFilters()"
      ></searchDialog>

      <!-- Help dialog -->
      <helpDialog
        v-if="help_dialog"
        helpID="1cadc0df-a938-4901-b7a1-db2a5b88ea0f"
        @closeDialog="closeHelpDialog()"
      >
      </helpDialog>
    </v-container>
  </Transition>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

#home-logs-container {
  max-width: 900px;
}

.patrol-type-button {
  font-size: 1.05rem;
}

.patrol-type-badge {
  width: 100%;
}

.fab-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  column-gap: 15px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}

.loader_button {
  width: 100% !important;
}

@media only screen and (max-width: 600px) {
  .patrol-type-button {
    font-size: 1.05rem;
    width: 80%;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import logsDialog from "./logs/logs_dialog.vue";
import searchDialog from "./logs/logs_search_dialog.vue";
const helpDialog = () => import("../components/help_dialog.vue");
export default {
  name: "Home-Logs",
  mixins: [bus_common],
  components: {
    logsDialog,
    searchDialog,
    helpDialog,
  },
  data() {
    return {
      drafts_type: { name: "Drafts", url: "drafts" },
      test: "",
      logs_dialog: false,
      logs_dialog_mode: "new",
      menuFAB: null,
      search_dialog: false,
      search_form: {
        logtype: "ALL",
        search_term: "",
        logEntryIDs: [],
        start_date: "",
        end_date: "",
      },
      const_search_form: {
        logtype: "ALL",
        search_term: "",
        logEntryIDs: [],
        start_date: "",
        end_date: "",
      },
      search_filters_text: "",
      loading_logs_list: ["", "", "", "", "", "", "", "", ""], // This array populates the loading buttons until we get the actual divisions
      recentDivisions: null,
      draftEntries: null,
      logs_dialog_logEntryIDs: [],
      help_dialog: false,
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.retrieveDivisionCount();
    },
    openLogType(url) {
      var qry_token = this.$route.query.token;
      this.$router.push({
        name: "home-divisions",
        params: { division: url },
        query: { token: qry_token },
      });
      },
      getColValue(index, length) {
          const isOddLength = length % 2 !== 0;
          const isLastItem = index === length - 1;

          if (this.$vuetify.breakpoint.mobile) {
              return 12;
          }
          else {
              if (isOddLength && isLastItem) {
                  return 12;
              } else {
                  return 6;
              }
          }      
      },

    // Logs dialog functions
    openDraftLogs() {
      this.logs_dialog_mode = "draft";
      this.logs_dialog_logEntryIDs = this.draftEntries;
      this.openLogsDialog();
    },
    openNewLogsDialog() {
      this.logs_dialog_mode = "new";
      this.openLogsDialog();
    },
    goHome() {
      var qry_token = this.$route.query.token;
      this.$router.push({ name: "home", query: { token: qry_token } });
    },
    openLogsDialog() {
      this.logs_dialog = true;
    },
    closeLogsDialog() {
      this.logs_dialog = false;
      this.init();
    },
    openHelpDialog() {
      this.help_dialog = true;
    },
    closeHelpDialog() {
      this.help_dialog = false;
    },
    logOut() {
      let callback = () => {
        window.location.replace(this.$store.state.loginURL);
      };
      this.swall_diag(
        "Log Out?",
        "Are you sure you would like to log out?",
        "question",
        callback,
        "Yes",
        "No",
        null,
        null
      );
    },
    openAdmin() {
      var qry_token = this.$route.query.token;
      this.$router.push({ name: "logs-admin", query: { token: qry_token } });
    },

    // Search Dialog functions
    openSearchDialog() {
      this.search_dialog = true;
      // Icon, re-focuses search bar, this prevents that
      this.$refs.search_field.blur();
    },
    closeSearchDialog() {
      this.search_dialog = false;
      // Icon, re-focuses search bar, this prevents that
      this.$refs.search_field.blur();
    },
    searchFiltersUpdated(data) {
      this.search_filters_text = data;
    },
    applySearchFilter() {
      this.closeSearchDialog();
      var qry_token = this.$route.query.token;
      this.$router.push({
        name: "logs-search",
        params: { prop_search_form: this.search_form },
        query: { token: qry_token },
      });
    },
    resetSearchFilters() {
      this.search_form = JSON.parse(JSON.stringify(this.const_search_form));
    },
    SearchLogs() {
      var qry_token = this.$route.query.token;
      this.$router.push({
        name: "logs-search",
        params: { prop_search_form: this.search_form },
        query: { token: qry_token },
      });
    },

    async retrieveDivisionCount() {
      var form = { token: this.$store.state.user.token };
      await this.$axios
        .post("/api/division/GetRecents", form)
        .then((response) => {
          this.recentDivisions = response.data.recentDivisions;
          this.draftEntries = response.data.draftEntries;

          // After receiving the recent divisions, we should set the data globally to cache it
          for (let i = 0; i < this.recentDivisions.length; i++) {
            const division = this.recentDivisions[i];
            let payload = {
              logDivisionID: division.logDivisionID,
              count: division.count,
            };
            this.$store.commit("setlogDivisionCount", payload);
          }
        })
        .catch((error) => {
          this.hande_swal_error(error, null);
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$store.state.user.token != "") {
        this.init();
      }
    });
  },
  computed: {
    logs_type_list() {
      if (this.recentDivisions) {
        return this.recentDivisions;
      } else {
        return this.$store.state.logDivisions;
      }
    },
    draft_count() {
      if (this.draftEntries) {
        return this.draftEntries.length;
      } else {
        return 0;
      }
    },
  },
  watch: {
    "$store.state.user.token": function () {
      if (this.$store.state.user.token != "") {
        this.init();
      }
    },
  },
};
</script>
